import httpManager from "@/app/shared/utils/httpManager";

export async function fetchFormsByTypification(ticketId, typification) {
  const url = `/workspace/tickets/${ticketId}/typification-form/`;
  const response = await httpManager.post(url, typification);
  return response.data;
}
